var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.538a8.462 8.462 0 100 16.924 8.462 8.462 0 000-16.924zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm15.672-3.62c.3.3.3.787 0 1.087l-7.18 7.18c-.3.3-.787.3-1.087 0L6.328 13.57a.77.77 0 011.088-1.088l2.533 2.533 6.635-6.636c.3-.3.788-.3 1.088 0z",
    fill: "#000"
  })));
}

export default SvgCheckCircle;